/* DT brand dropdown enhancer.
   Non-destructive: wraps native <select> elements (calculator only) with a brand
   dark-glass dropdown. The native select stays the source of truth — selecting an
   option writes back to it and fires native input+change, so existing logic is
   untouched and still works if this script never loads. */
(function () {
  'use strict';

  var STYLE_ID = 'dt-ddx-style';
  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var css = [
      '.dt-ddx-native{position:absolute!important;width:1px!important;height:1px!important;opacity:0!important;pointer-events:none!important;margin:0!important;padding:0!important;border:0!important;overflow:hidden!important;clip:rect(0 0 0 0)!important;clip-path:inset(50%)!important;}',
      '.dt-ddx{position:relative;}',
      '.dt-ddx__btn{width:100%;display:flex;align-items:center;justify-content:space-between;gap:10px;background:rgba(255,255,255,.05);border:1px solid rgba(255,255,255,.18);border-radius:12px;padding:14px 16px;color:#fff;font-family:inherit;font-size:15px;line-height:1.3;cursor:pointer;text-align:left;transition:border-color .2s ease,box-shadow .2s ease;}',
      '.dt-ddx__btn:focus-visible,.dt-ddx.open .dt-ddx__btn{outline:none;border-color:var(--dt-accent,#E50914);box-shadow:0 0 0 3px rgba(229,9,20,.16);}',
      '.dt-ddx__val{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}',
      '.dt-ddx__val.is-ph{color:rgba(255,255,255,.5);}',
      '.dt-ddx__arr{display:inline-flex;flex:0 0 auto;}',
      '.dt-ddx__arr svg{width:16px;height:16px;stroke:rgba(255,255,255,.6);fill:none;stroke-width:2;stroke-linecap:round;transition:transform .2s ease;}',
      '.dt-ddx.open .dt-ddx__arr svg{transform:rotate(180deg);}',
      '.dt-ddx__menu{position:absolute;left:0;top:calc(100% + 8px);z-index:60;min-width:100%;width:max-content;max-width:340px;padding:6px;border-radius:14px;background:#16161c;border:1px solid rgba(255,255,255,.16);box-shadow:0 22px 50px rgba(0,0,0,.6),inset 0 1px 0 rgba(255,255,255,.07);max-height:300px;overflow-y:auto;opacity:0;visibility:hidden;transform:translateY(-6px);transition:opacity .18s ease,transform .18s ease,visibility .18s;}',
      '.dt-ddx.open .dt-ddx__menu{opacity:1;visibility:visible;transform:translateY(0);}',
      '.dt-ddx__opt{display:flex;align-items:center;justify-content:space-between;gap:10px;padding:12px 14px;border-radius:9px;font-size:15px;color:rgba(255,255,255,.82);cursor:pointer;transition:background .15s ease,color .15s ease;}',
      '.dt-ddx__opt:hover{background:rgba(229,9,20,.16);color:#fff;}',
      '.dt-ddx__opt[aria-selected="true"]{color:#fff;}',
      '.dt-ddx__opt[aria-selected="true"]::after{content:"";width:7px;height:7px;border-radius:50%;background:var(--dt-accent,#E50914);flex:0 0 auto;}',
      '.dt-ddx__opt[aria-disabled="true"]{opacity:.4;pointer-events:none;}',
      '.dt-ddx.is-disabled{opacity:.55;pointer-events:none;}'
    ].join('');
    var st = document.createElement('style');
    st.id = STYLE_ID;
    st.textContent = css;
    document.head.appendChild(st);
  }

  function isTarget(sel) {
    if (sel.dataset.dtDdx) return false;
    var sec = sel.closest('.shopify-section');
    return !!(sec && sec.id && sec.id.indexOf('__calculator') > -1);
  }

  function closeAll(except) {
    var open = document.querySelectorAll('.dt-ddx.open');
    for (var i = 0; i < open.length; i++) {
      if (open[i] !== except) {
        open[i].classList.remove('open');
        var b = open[i].querySelector('.dt-ddx__btn');
        if (b) b.setAttribute('aria-expanded', 'false');
      }
    }
  }

  function enhance(sel) {
    if (sel.dataset.dtDdx) return;
    sel.dataset.dtDdx = '1';

    var wrap = document.createElement('div'); wrap.className = 'dt-ddx';
    var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'dt-ddx__btn';
    btn.setAttribute('aria-haspopup', 'listbox'); btn.setAttribute('aria-expanded', 'false');
    var val = document.createElement('span'); val.className = 'dt-ddx__val';
    var arr = document.createElement('span'); arr.className = 'dt-ddx__arr';
    arr.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>';
    btn.appendChild(val); btn.appendChild(arr);
    var menu = document.createElement('div'); menu.className = 'dt-ddx__menu'; menu.setAttribute('role', 'listbox');

    /* take the select's exact layout slot, then nest the (hidden) select inside */
    sel.parentNode.insertBefore(wrap, sel);
    wrap.appendChild(sel); wrap.appendChild(btn); wrap.appendChild(menu);
    sel.classList.add('dt-ddx-native'); sel.setAttribute('tabindex', '-1'); sel.setAttribute('aria-hidden', 'true');

    var lastIdx = -2;

    function build() {
      menu.innerHTML = '';
      for (var i = 0; i < sel.options.length; i++) {
        (function (i) {
          var opt = sel.options[i];
          var o = document.createElement('div'); o.className = 'dt-ddx__opt'; o.setAttribute('role', 'option');
          o.textContent = opt.textContent; o.setAttribute('data-i', i);
          if (opt.disabled) o.setAttribute('aria-disabled', 'true');
          o.addEventListener('click', function (e) {
            e.stopPropagation();
            if (opt.disabled) return;
            if (sel.selectedIndex !== i) {
              sel.selectedIndex = i;
              sel.dispatchEvent(new Event('input', { bubbles: true }));
              sel.dispatchEvent(new Event('change', { bubbles: true }));
            }
            sync(); wrap.classList.remove('open'); btn.setAttribute('aria-expanded', 'false');
          });
          menu.appendChild(o);
        })(i);
      }
    }

    function sync() {
      var idx = sel.selectedIndex; lastIdx = idx;
      var opt = sel.options[idx] || sel.options[0];
      val.textContent = opt ? opt.textContent : '';
      var isPh = idx <= 0 && opt && /please|select|choose/i.test(opt.textContent);
      val.classList.toggle('is-ph', !!isPh);
      for (var k = 0; k < menu.children.length; k++) {
        menu.children[k].setAttribute('aria-selected', String(Number(menu.children[k].getAttribute('data-i')) === idx));
      }
      wrap.classList.toggle('is-disabled', !!sel.disabled);
    }

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (sel.disabled) return;
      var willOpen = !wrap.classList.contains('open');
      closeAll(wrap);
      wrap.classList.toggle('open', willOpen);
      btn.setAttribute('aria-expanded', String(willOpen));
    });

    sel.addEventListener('change', sync);
    new MutationObserver(function () { build(); sync(); }).observe(sel, { childList: true });

    build(); sync();
    wrap._dtSync = function () { if (sel.selectedIndex !== lastIdx) sync(); };
  }

  function scan(root) {
    var list = (root || document).querySelectorAll('select');
    for (var i = 0; i < list.length; i++) { if (isTarget(list[i])) enhance(list[i]); }
  }

  function init() {
    injectStyle();
    scan(document);
    document.addEventListener('click', function () { closeAll(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

    var calcs = document.querySelectorAll('[id*="__calculator"]');
    for (var i = 0; i < calcs.length; i++) {
      new MutationObserver(function (muts) {
        for (var m = 0; m < muts.length; m++) {
          var added = muts[m].addedNodes;
          for (var a = 0; a < added.length; a++) {
            var n = added[a];
            if (n.nodeType !== 1) continue;
            if (n.tagName === 'SELECT' && isTarget(n)) enhance(n);
            else if (n.querySelectorAll) scan(n);
          }
        }
      }).observe(calcs[i], { childList: true, subtree: true });
    }

    /* backstop: catch programmatic value changes (Reset, dependent fields) that don't fire change */
    setInterval(function () {
      var ws = document.querySelectorAll('.dt-ddx');
      for (var i = 0; i < ws.length; i++) { if (ws[i]._dtSync) ws[i]._dtSync(); }
    }, 500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
